export default __webpack_public_path__ + "static/media/bosch_ui_icon_rtl.3a8e6bf7.woff";